module.exports = __webpack_public_path__ + "img/404.77f9029b.png";